"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.ErrorScreenReason=void 0;var r;(function(e){e.MissingCategoryId="MISSING_CATEGORY_ID",e.OutOfDeliveryArea="OUT_OF_DELIVERY_AREA"})(r||(exports.ErrorScreenReason=r={}));
//# sourceMappingURL=ErrorScreenReason.js.map
